// extracted by mini-css-extract-plugin
module.exports = {"root":"timer-redirect-to_root__2-88K","footer":"timer-redirect-to_footer__X1HmL"};